<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// 根组件
</script>

<style>
/* 全局样式在 main.css 中 */
</style>
